// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { isMobileFun } from './common/utils'

window.isMobile = isMobileFun()
Vue.config.productionTip = false

Vue.mixin({
  data () {
    return {
      isMobile: window.isMobile
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

if (window.isMobile) document.querySelector('html').style.fontSize = `${document.body.clientWidth / 375 * 16}px`


// WEBPACK FOOTER //
// ./src/main.js